const emailRegexp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const shortCodeRegexp = /^[A-Z0-9]{3}-[A-Z0-9]{3}-[A-Z0-9]{3}$/;

export const hasSpaces = (text = '') => text.indexOf(' ') > -1;
export const isEmpty = (text = '') => text.trim().length === 0;
export const isValidEmail = (email) => emailRegexp.test(email);
export const isValidShortCode = (code) => shortCodeRegexp.test(code);



// WEBPACK FOOTER //
// ./src/services/Validation.js